import * as ambassadorWixWorkflowsV1Card from './workflows-v1-card-cards.http.js';
import * as ambassadorWixWorkflowsV1CardTypes from './workflows-v1-card-cards.types.js';
import * as ambassadorWixWorkflowsV1CardUniversalTypes from './workflows-v1-card-cards.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function listCards(): __PublicMethodMetaInfo<
  'GET',
  { workflowId: string },
  ambassadorWixWorkflowsV1CardUniversalTypes.ListCardsRequest,
  ambassadorWixWorkflowsV1CardTypes.ListCardsRequest,
  ambassadorWixWorkflowsV1CardUniversalTypes.ListCardsResponse,
  ambassadorWixWorkflowsV1CardTypes.ListCardsResponse
> {
  const payload = { workflowId: ':workflowId' } as any;

  const getRequestOptions = ambassadorWixWorkflowsV1Card.listCards(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/workflows/{workflowId}/cards',
    pathParams: { workflowId: 'workflowId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getCard(): __PublicMethodMetaInfo<
  'GET',
  { id: string },
  ambassadorWixWorkflowsV1CardUniversalTypes.GetCardRequest,
  ambassadorWixWorkflowsV1CardTypes.GetCardRequest,
  ambassadorWixWorkflowsV1CardUniversalTypes.GetCardResponse,
  ambassadorWixWorkflowsV1CardTypes.GetCardResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions = ambassadorWixWorkflowsV1Card.getCard(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/cards/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateCard(): __PublicMethodMetaInfo<
  'PATCH',
  { id: string },
  ambassadorWixWorkflowsV1CardUniversalTypes.UpdateCardRequest,
  ambassadorWixWorkflowsV1CardTypes.UpdateCardRequest,
  ambassadorWixWorkflowsV1CardUniversalTypes.UpdateCardResponse,
  ambassadorWixWorkflowsV1CardTypes.UpdateCardResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions = ambassadorWixWorkflowsV1Card.updateCard(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/cards/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createCard(): __PublicMethodMetaInfo<
  'POST',
  { workflowId: string; phaseId: string },
  ambassadorWixWorkflowsV1CardUniversalTypes.CreateCardRequest,
  ambassadorWixWorkflowsV1CardTypes.CreateCardRequest,
  ambassadorWixWorkflowsV1CardUniversalTypes.CreateCardResponse,
  ambassadorWixWorkflowsV1CardTypes.CreateCardResponse
> {
  const payload = { workflowId: ':workflowId', phaseId: ':phaseId' } as any;

  const getRequestOptions = ambassadorWixWorkflowsV1Card.createCard(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/workflows/{workflowId}/phases/{phaseId}/cards',
    pathParams: { workflowId: 'workflowId', phaseId: 'phaseId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteCard(): __PublicMethodMetaInfo<
  'DELETE',
  { id: string },
  ambassadorWixWorkflowsV1CardUniversalTypes.DeleteCardRequest,
  ambassadorWixWorkflowsV1CardTypes.DeleteCardRequest,
  ambassadorWixWorkflowsV1CardUniversalTypes.DeleteCardResponse,
  ambassadorWixWorkflowsV1CardTypes.DeleteCardResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions = ambassadorWixWorkflowsV1Card.deleteCard(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/cards/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function moveCard(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixWorkflowsV1CardUniversalTypes.MoveCardRequest,
  ambassadorWixWorkflowsV1CardTypes.MoveCardRequest,
  ambassadorWixWorkflowsV1CardUniversalTypes.MoveCardResponse,
  ambassadorWixWorkflowsV1CardTypes.MoveCardResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions = ambassadorWixWorkflowsV1Card.moveCard(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/cards/{id}/move',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function restoreCard(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixWorkflowsV1CardUniversalTypes.RestoreCardRequest,
  ambassadorWixWorkflowsV1CardTypes.RestoreCardRequest,
  ambassadorWixWorkflowsV1CardUniversalTypes.RestoreCardResponse,
  ambassadorWixWorkflowsV1CardTypes.RestoreCardResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions = ambassadorWixWorkflowsV1Card.restoreCard(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/cards/{id}/restore',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function archiveCard(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixWorkflowsV1CardUniversalTypes.ArchiveCardRequest,
  ambassadorWixWorkflowsV1CardTypes.ArchiveCardRequest,
  ambassadorWixWorkflowsV1CardUniversalTypes.ArchiveCardResponse,
  ambassadorWixWorkflowsV1CardTypes.ArchiveCardResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions = ambassadorWixWorkflowsV1Card.archiveCard(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/cards/{id}/archive',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Card as CardOriginal,
  CardInfo as CardInfoOriginal,
  Attachment as AttachmentOriginal,
  AttachmentType as AttachmentTypeOriginal,
  AttachmentTypeWithLiterals as AttachmentTypeWithLiteralsOriginal,
  QueryCardsRequest as QueryCardsRequestOriginal,
  Query as QueryOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  QueryCardsResponse as QueryCardsResponseOriginal,
  PaginationResponse as PaginationResponseOriginal,
  ListCardsRequest as ListCardsRequestOriginal,
  ListCardsResponse as ListCardsResponseOriginal,
  GetCardRequest as GetCardRequestOriginal,
  GetCardResponse as GetCardResponseOriginal,
  UpdateCardRequest as UpdateCardRequestOriginal,
  UpdateCardResponse as UpdateCardResponseOriginal,
  CreateCardRequest as CreateCardRequestOriginal,
  CreateCardResponse as CreateCardResponseOriginal,
  DeleteCardRequest as DeleteCardRequestOriginal,
  DeleteCardResponse as DeleteCardResponseOriginal,
  MoveCardRequest as MoveCardRequestOriginal,
  MoveCardResponse as MoveCardResponseOriginal,
  RestoreCardRequest as RestoreCardRequestOriginal,
  RestoreCardResponse as RestoreCardResponseOriginal,
  ArchiveCardRequest as ArchiveCardRequestOriginal,
  ArchiveCardResponse as ArchiveCardResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './workflows-v1-card-cards.types.js';
